import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Pagination } from '../../models/pagination';

@Component({
  selector: 'lib-client-side-pagination',
  templateUrl: './client-side-pagination.component.html',
  styleUrls: ['./client-side-pagination.component.css'],
  standalone: false
})
export class ClientSidePaginationComponent implements OnInit {
  private _collection: any[] = [];

  @Input() set collection(value: any[]) {
    this._collection = value;
    this._initPagination();
  }
  @Input()
  public perPage: number = 25;

  @Input()
  public sendPageOnInit = true;

  @Output()
  public currentPage = new EventEmitter<any[]>();

  public pagination: Pagination;

  ngOnInit() {
    this._initPagination();
  }

  public pageChanged({ Page }: Pagination) {
    this.pagination.Page = Page;
    const start = (Page - 1) * this.pagination.PerPage;
    const end = start + this.pagination.PerPage;
    const page = this._collection.slice(start, end);
    this.currentPage.next(page);
  }

  private _initPagination() {
    if (this.pagination == null) {
      this.pagination = new Pagination();
      this.pagination.PerPage = this.perPage;
      this.pagination.Total = this._collection.length;
      this.pagination.Pages = Math.ceil(this._collection.length / this.pagination.PerPage);
    }
    this.pagination.Page = 1;

    console.log(this.pagination);
    if (this.sendPageOnInit) {
      this.pageChanged(this.pagination);
    }
  }
}
